var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLisFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69063 16.0594C2.39687 15.7656 2.25 15.4125 2.25 15V4.5C2.25 4.0875 2.39687 3.73438 2.69063 3.44063C2.98438 3.14688 3.3375 3 3.75 3H4.5V1.5H6V3H12V1.5H13.5V3H14.25C14.6625 3 15.0156 3.14688 15.3094 3.44063C15.6031 3.73438 15.75 4.0875 15.75 4.5V8.25H14.25V7.5H3.75V15H9V16.5H3.75ZM3.75 6H14.25V4.5H3.75V6ZM10.5 16.5V14.1938L14.6438 10.0688C14.7563 9.95625 14.8813 9.875 15.0188 9.825C15.1563 9.775 15.2938 9.75 15.4313 9.75C15.5813 9.75 15.725 9.77813 15.8625 9.83438C16 9.89062 16.125 9.975 16.2375 10.0875L16.9313 10.7812C17.0313 10.8938 17.1094 11.0188 17.1656 11.1562C17.2219 11.2938 17.25 11.4313 17.25 11.5688C17.25 11.7063 17.225 11.8469 17.175 11.9906C17.125 12.1344 17.0438 12.2625 16.9313 12.375L12.8063 16.5H10.5ZM11.625 15.375H12.3375L14.6063 13.0875L14.2688 12.7313L13.9125 12.3938L11.625 14.6625V15.375ZM14.2688 12.7313L13.9125 12.3938L14.6063 13.0875L14.2688 12.7313Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLisFlight);
export default __webpack_public_path__ + "static/media/lisFlight.2544b55bc545bca470b78bcb93e6b9af.svg";
export { ForwardRef as ReactComponent };